import React from 'react';
import { useNavigate } from 'react-router-dom';
import ApprovalPage from './ApprovalPage';

const AdminApprovalPage = () => {
  const navigate = useNavigate();
  
  const handleBack = () => {
    navigate('/');
  };

  return <ApprovalPage onBack={handleBack} />;
};

export default AdminApprovalPage;
